'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function responsivePropClassName(prop, prefix) {
    if (Array.isArray(prop)) {
        const [desktop, mobile] = prop;
        return prefix
            ? classNames__default["default"](`${prefix}-${desktop}`, `${prefix}-mobile-${mobile}`)
            : classNames__default["default"](desktop, `mobile-${mobile}`);
    }
    else {
        return prefix ? `${prefix}-${prop}` : prop;
    }
}

const Base = React__default["default"].forwardRef((_a, ref) => {
    var { as = 'div', mb, className } = _a, props = __rest(_a, ["as", "mb", "className"]);
    const Component = as;
    const marginBottomClassName = mb && responsivePropClassName(mb, `cf-mb`);
    return (jsxRuntime.jsx(Component, Object.assign({ className: classNames__default["default"](marginBottomClassName, className), ref: ref }, props), void 0));
});

const Button = React__default["default"].forwardRef((_a, ref) => {
    var { as = 'button', variant = 'primary', size = 'small', color = 'black', className, children, rightIcon, leftIcon } = _a, props = __rest(_a, ["as", "variant", "size", "color", "className", "children", "rightIcon", "leftIcon"]);
    return (jsxRuntime.jsxs(Base, Object.assign({ className: classNames__default["default"](`cf-button`, variant, size, className, color) }, props, { as: as, ref: ref }, { children: [leftIcon && jsxRuntime.jsx("span", Object.assign({ className: 'left-icon' }, { children: leftIcon }), void 0), children, rightIcon && jsxRuntime.jsx("span", Object.assign({ className: 'right-icon' }, { children: rightIcon }), void 0)] }), void 0));
});

const Checkbox = React__default["default"].forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (jsxRuntime.jsx("input", Object.assign({}, props, { type: 'checkbox', className: classNames__default["default"](`cf-checkbox`, className), ref: ref }), void 0));
});

function Header(_a) {
    var { as = 'h1', size = 'xxlarge', className } = _a, props = __rest(_a, ["as", "size", "className"]);
    return (jsxRuntime.jsx(Base, Object.assign({ className: classNames__default["default"]('cf-header', size, className), as: as }, props), void 0));
}

function Text(_a) {
    var { as = 'p', size = 'medium', className } = _a, props = __rest(_a, ["as", "size", "className"]);
    return (jsxRuntime.jsx(Base, Object.assign({ className: classNames__default["default"](`cf-text`, size, className), as: as }, props), void 0));
}

function HTMLText(_a) {
    var { as = 'div', className, children } = _a, props = __rest(_a, ["as", "className", "children"]);
    return (jsxRuntime.jsx(Text, Object.assign({ className: classNames__default["default"](`cf-html-text`, className), as: as, dangerouslySetInnerHTML: { __html: children } }, props), void 0));
}

var _path$k;

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var SvgDottedMenu = function SvgDottedMenu(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor"
  })));
};

var _path$j;

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.749 6.451H0v-1.7h12.749L9.2 1.202 10.402 0l5.601 5.601-5.6 5.601L9.2 10l3.549-3.549Z",
    fill: "currentColor"
  })));
};

var _path$i;

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.875 1h-1.75v6.125H1v1.75h6.125V15h1.75V8.875H15v-1.75H8.875V1Z",
    fill: "currentColor"
  })));
};

var _circle, _path$h;

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#fff",
    stroke: "currentColor"
  })), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.157 12 8 15.157l.843.843L12 12.843 15.157 16l.843-.843L12.843 12 16 8.843 15.157 8 12 11.157 8.843 8 8 8.843 11.157 12Z",
    fill: "currentColor"
  })));
};

var _path$g;

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.524 7 0 12.524 1.476 14 7 8.476 12.524 14 14 12.524 8.476 7 14 1.476 12.524 0 7 5.524 1.476 0 0 1.476 5.524 7Z",
    fill: "currentColor"
  })));
};

var _path$f;

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.453 5.924 11.43 0 5.564 1.468 4.11l4.456 4.411L14.532 0 16 1.453Z",
    fill: "currentColor"
  })));
};

var _path$e;

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.302 16H1.698a1.697 1.697 0 0 1-1.517-2.455L6.483.938c.625-1.25 2.409-1.25 3.034 0l6.302 12.607A1.697 1.697 0 0 1 14.302 16ZM7 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4Zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z",
    fill: "currentColor"
  })));
};

var _path$d;

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7 3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 6a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1Z",
    fill: "currentColor"
  })));
};

var _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7 7c1.819 0 3.293-1.567 3.293-3.5S8.82 0 7 0C5.181 0 3.707 1.567 3.707 3.5S5.18 7 7 7ZM3.558 9C2.263 9 1.134 9.937.82 11.272l-.763 2.243C-.24 14.777.66 16 1.883 16h10.234c1.224 0 2.123-1.223 1.826-2.485l-.763-2.243C12.866 9.937 11.737 9 10.442 9H3.558Z",
    fill: "currentColor"
  })));
};

var _path$b;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 0h16v2.5H0V0ZM0 13.5h16V16H0v-2.5ZM16 6.75H0v2.5h16v-2.5Z",
    fill: "currentColor"
  })));
};

var _path$a;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var SvgStopWatch = function SvgStopWatch(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7 0a.2.2 0 0 0-.2.2v1.3c0 .11.09.2.2.2h1.95v1.355a6.501 6.501 0 1 0 6.463 3.165l.742-.742a.2.2 0 0 0 0-.283l-2.054-2.054a.2.2 0 0 0-.282 0l-.743.743a6.457 6.457 0 0 0-2.426-.829V1.7H9.3a.2.2 0 0 0 .2-.2V.2a.2.2 0 0 0-.2-.2H3.7Zm2.8 14.3a4.8 4.8 0 1 0 0-9.6v9.6Z",
    fill: "currentColor"
  })));
};

var _path$9, _path2$3;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var SvgLoad = function SvgLoad(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M2.799 5.737A1 1 0 0 1 3.764 5h8.472a1 1 0 0 1 .965.737l2.454 9A1 1 0 0 1 14.691 16H1.309a1 1 0 0 1-.965-1.263l2.455-9Z",
    fill: "currentColor"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  })));
};

var _path$8;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var SvgReps = function SvgReps(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.854 1.25a.25.25 0 0 1 .25-.25h1.25a.25.25 0 0 1 .25.25v7.714l1.75-.807V1.25a.25.25 0 0 1 .25-.25h1.25a.25.25 0 0 1 .25.25v6.1l1.75-.807V1.25a.25.25 0 0 1 .25-.25h1.25a.25.25 0 0 1 .25.25v4.486l1.75-.807V1.25a.25.25 0 0 1 .25-.25h1.25a.25.25 0 0 1 .25.25v2.872l.742-.342a.25.25 0 0 1 .332.122l.628 1.362a.25.25 0 0 1-.122.332l-1.58.728v8.426a.25.25 0 0 1-.25.25h-1.25a.25.25 0 0 1-.25-.25V7.131l-1.75.807v6.812a.25.25 0 0 1-.25.25h-1.25a.25.25 0 0 1-.25-.25V8.745l-1.75.807v5.198a.25.25 0 0 1-.25.25h-1.25a.25.25 0 0 1-.25-.25v-4.39l-1.75.806v3.584a.25.25 0 0 1-.25.25h-1.25a.25.25 0 0 1-.25-.25v-2.777l-.7.323a.25.25 0 0 1-.332-.123l-.628-1.362a.25.25 0 0 1 .123-.332l1.537-.708V1.25Z",
    fill: "currentColor"
  })));
};

var _path$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.456 11.658a6.5 6.5 0 1 1 1.202-1.202L16 14.798 14.798 16l-4.342-4.342ZM11.3 6.5a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0Z",
    fill: "currentColor"
  })));
};

var _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var SvgWeights = function SvgWeights(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M3 0h1.7v9H3V0ZM0 1.5h1.7v6H0v-6ZM13 0h-1.7v9H13V0ZM14.3 1.5H16v6h-1.7v-6ZM10 3.65H6v1.7h4v-1.7Z",
    fill: "currentColor"
  })));
};

var _path$5, _path2$2;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var SvgMedal = function SvgMedal(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M8.13 7.458a.11.11 0 0 0-.204 0l-.604 1.558-1.668.093a.11.11 0 0 0-.063.194l1.295 1.056-.427 1.615a.11.11 0 0 0 .165.12l1.404-.905 1.405.905a.11.11 0 0 0 .165-.12L9.17 10.36l1.296-1.056a.11.11 0 0 0-.063-.194l-1.67-.093-.603-1.558Z",
    fill: "currentColor"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.728 4.006a6.1 6.1 0 0 1 .544 0l2.623-3.94A.15.15 0 0 1 11.019 0h1.682a.15.15 0 0 1 .125.233l-2.753 4.135c.263.097.517.211.76.342l3.06-4.643A.15.15 0 0 1 14.016 0h1.677c.12 0 .19.133.125.233l-3.615 5.486a6 6 0 1 1-8.408 0L.181.233A.15.15 0 0 1 .307 0h1.676a.15.15 0 0 1 .125.067L5.167 4.71c.244-.131.497-.245.76-.342L3.174.233A.15.15 0 0 1 3.3 0h1.682a.15.15 0 0 1 .125.067l2.622 3.939ZM8 14.3a4.3 4.3 0 1 0 0-8.6 4.3 4.3 0 0 0 0 8.6Z",
    fill: "currentColor"
  })));
};

var _path$4, _path2$1;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9 1.5H2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2V8H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7.5V6.5H9a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5Z",
    fill: "currentColor"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14 4.5h-2V3h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1.5v1.5H7a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5Z",
    fill: "currentColor"
  })));
};

var _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.425 4.62A1 1 0 0 0 0 5.438V13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5.438a1 1 0 0 0-.425-.818l-6-4.216a1 1 0 0 0-1.15 0l-6 4.216ZM1.7 12.3h10.6V5.802L7 2.078 1.7 5.802V12.3Z",
    fill: "currentColor"
  })));
};

var _path$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.688 0h2.625l.373 2.24c.448.131.875.313 1.273.54l1.858-1.328 1.856 1.856-1.36 1.903c.208.395.373.816.49 1.256l2.072.346v2.625l-2.148.358c-.13.412-.302.806-.513 1.174l1.282 1.795-1.856 1.856-1.84-1.314a5.952 5.952 0 0 1-1.114.453L10.313 16H7.687l-.373-2.24a5.954 5.954 0 0 1-1.115-.453l-1.84 1.314-1.856-1.856 1.283-1.795a5.965 5.965 0 0 1-.499-1.13L.875 9.438V6.812l2.334-.389a5.96 5.96 0 0 1 .477-1.212l-1.36-1.903 1.857-1.856L6.04 2.779a5.965 5.965 0 0 1 1.273-.539L7.687 0ZM9 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "currentColor"
  })));
};

var _path$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.535 12.725 0 14 1.232 7 8 0 1.232 1.275 0 7 5.535Z",
    fill: "currentColor"
  })));
};

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgClassPlan = function SvgClassPlan(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.5 5H10V4H4.5v1ZM11.004 7.55l-6.5.05-.008-1 6.5-.05.008 1ZM4.5 10.15h4v-1h-4v1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 .6a.6.6 0 0 1 .6-.6h12.8a.6.6 0 0 1 .6.6v14.8a.6.6 0 0 1-.6.6H1.6a.6.6 0 0 1-.6-.6V.6Zm1.7 13.7V1.7h10.6v12.6H2.7Z",
    fill: "currentColor"
  })));
};

function Icon(_a) {
    var { name } = _a, props = __rest(_a, ["name"]);
    const className = classNames__default["default"]('cf-icon', props.className);
    switch (name) {
        case 'dotted-menu':
            return jsxRuntime.jsx(SvgDottedMenu, Object.assign({}, props, { className: className }), void 0);
        case 'arrow-right':
            return jsxRuntime.jsx(SvgArrowRight, Object.assign({}, props, { className: className }), void 0);
        case 'plus':
            return jsxRuntime.jsx(SvgPlus, Object.assign({}, props, { className: className }), void 0);
        case 'close-circle':
            return jsxRuntime.jsx(SvgCloseCircle, Object.assign({}, props, { className: className }), void 0);
        case 'close':
            return jsxRuntime.jsx(SvgClose, Object.assign({}, props, { className: className }), void 0);
        case 'check':
            return jsxRuntime.jsx(SvgCheck, Object.assign({}, props, { className: className }), void 0);
        case 'alert':
            return jsxRuntime.jsx(SvgAlert, Object.assign({}, props, { className: className }), void 0);
        case 'info':
            return jsxRuntime.jsx(SvgInfo, Object.assign({}, props, { className: className }), void 0);
        case 'user':
            return jsxRuntime.jsx(SvgUser, Object.assign({}, props, { className: className }), void 0);
        case 'hamburger':
            return jsxRuntime.jsx(SvgHamburger, Object.assign({}, props, { className: className }), void 0);
        case 'stop-watch':
            return jsxRuntime.jsx(SvgStopWatch, Object.assign({}, props, { className: className }), void 0);
        case 'load':
            return jsxRuntime.jsx(SvgLoad, Object.assign({}, props, { className: className }), void 0);
        case 'reps':
            return jsxRuntime.jsx(SvgReps, Object.assign({}, props, { className: className }), void 0);
        case 'search':
            return jsxRuntime.jsx(SvgSearch, Object.assign({}, props, { className: className }), void 0);
        case 'weights':
            return jsxRuntime.jsx(SvgWeights, Object.assign({}, props, { className: className }), void 0);
        case 'medal':
            return jsxRuntime.jsx(SvgMedal, Object.assign({}, props, { className: className }), void 0);
        case 'link':
            return jsxRuntime.jsx(SvgLink, Object.assign({}, props, { className: className }), void 0);
        case 'home':
            return jsxRuntime.jsx(SvgHome, Object.assign({}, props, { className: className }), void 0);
        case 'settings':
            return jsxRuntime.jsx(SvgSettings, Object.assign({}, props, { className: className }), void 0);
        case 'chevron':
            return jsxRuntime.jsx(SvgChevron, Object.assign({}, props, { className: className }), void 0);
        case 'class-plan':
            return jsxRuntime.jsx(SvgClassPlan, Object.assign({}, props, { className: className }), void 0);
    }
}

const Input = React__default["default"].forwardRef((_a, ref) => {
    var { isInvalid, type = 'text', className } = _a, props = __rest(_a, ["isInvalid", "type", "className"]);
    return (jsxRuntime.jsx("input", Object.assign({ type: type, className: classNames__default["default"](`cf-input`, { invalid: isInvalid }, className) }, props, { ref: ref }), void 0));
});

function Label(_a) {
    var { as = 'label', className } = _a, props = __rest(_a, ["as", "className"]);
    return (jsxRuntime.jsx(Base, Object.assign({ className: classNames__default["default"](`cf-label`, className), as: as }, props), void 0));
}

function Loader(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return jsxRuntime.jsx("div", Object.assign({ className: classNames__default["default"](`cf-loader`, className) }, props), void 0);
}

function Modal(_a) {
    var { header, canBeDismissed = true, showCloseButton = true, onClose, children } = _a, props = __rest(_a, ["header", "canBeDismissed", "showCloseButton", "onClose", "children"]);
    return (jsxRuntime.jsx("div", Object.assign({ className: 'cf-modal', onClick: () => canBeDismissed && onClose }, { children: jsxRuntime.jsxs("div", Object.assign({ className: 'box' }, props, { onClick: (e) => e.stopPropagation() }, { children: [canBeDismissed && showCloseButton && (jsxRuntime.jsx("button", Object.assign({ className: 'close-button', onClick: onClose }, { children: jsxRuntime.jsx(Icon, { name: 'close', className: 'icon' }, void 0) }), void 0)), jsxRuntime.jsx("header", Object.assign({ className: 'header' }, { children: header }), void 0), jsxRuntime.jsx("main", Object.assign({ className: 'body' }, { children: children }), void 0)] }), void 0) }), void 0));
}

const Notification = React__default["default"].forwardRef((_a, ref) => {
    var { as = 'div', variant = 'success', className, onClick, children } = _a, props = __rest(_a, ["as", "variant", "className", "onClick", "children"]);
    const Component = as;
    const iconName = React.useMemo(() => {
        switch (variant) {
            case 'warning':
                return 'alert';
            case 'info':
                return 'info';
            case 'error':
                return 'close';
            default:
                return 'check';
        }
    }, [variant]);
    return (jsxRuntime.jsxs(Component, Object.assign({ className: classNames__default["default"]('cf-notification', variant, className) }, props, { ref: ref }, { children: [jsxRuntime.jsx(Icon, { name: iconName, className: 'icon' }, void 0), children, jsxRuntime.jsx("button", Object.assign({ className: 'close-button', onClick: onClick }, { children: jsxRuntime.jsx(Icon, { name: 'close' }, void 0) }), void 0)] }), void 0));
});

function OverlineText(_a) {
    var { as = 'p', size = 'medium', className } = _a, props = __rest(_a, ["as", "size", "className"]);
    return (jsxRuntime.jsx(Base, Object.assign({ className: classNames__default["default"]('cf-overline-text', size, className), as: as }, props), void 0));
}

const Select = React__default["default"].forwardRef((_a, ref) => {
    var { isInvalid, className } = _a, props = __rest(_a, ["isInvalid", "className"]);
    return (jsxRuntime.jsx("select", Object.assign({ className: classNames__default["default"](`cf-select`, { invalid: isInvalid }, className) }, props, { ref: ref }), void 0));
});

function Stack(_a) {
    var { direction = 'vertical', spacing, className } = _a, props = __rest(_a, ["direction", "spacing", "className"]);
    const directionClassName = responsivePropClassName(direction);
    const spacingClassName = spacing && responsivePropClassName(spacing, `cf-gap`);
    return (jsxRuntime.jsx(Base, Object.assign({ className: classNames__default["default"]('cf-stack', spacingClassName, directionClassName, className) }, props), void 0));
}

const Textarea = React__default["default"].forwardRef((_a, ref) => {
    var { isInvalid, className } = _a, props = __rest(_a, ["isInvalid", "className"]);
    return (jsxRuntime.jsx("textarea", Object.assign({ className: classNames__default["default"](`cf-textarea`, { invalid: isInvalid }, className) }, props, { ref: ref }), void 0));
});

function Toggle(_a) {
    var { className, trueText = 'yes', falseText = 'no' } = _a, props = __rest(_a, ["className", "trueText", "falseText"]);
    return (jsxRuntime.jsxs("div", Object.assign({ className: classNames__default["default"]('cf-toggle', className) }, { children: [jsxRuntime.jsx("input", Object.assign({}, props, { className: 'input', type: 'checkbox' }), void 0), jsxRuntime.jsx("label", Object.assign({ className: 'label', htmlFor: props.id }, { children: jsxRuntime.jsx("div", { children: props.checked ? trueText : falseText }, void 0) }), void 0)] }), void 0));
}

function ToggleSwitch(_a) {
    var { options, selectedOption } = _a, props = __rest(_a, ["options", "selectedOption"]);
    return (jsxRuntime.jsx(Base, Object.assign({ as: 'button', className: 'cf-toggle-switch', "aria-pressed": selectedOption === 1 ? `true` : `false` }, props, { children: options.map((option) => (jsxRuntime.jsxs("div", Object.assign({ className: 'option' }, { children: [option, jsxRuntime.jsx("div", Object.assign({ className: 'highlighted-option' }, { children: option }), void 0)] }), option))) }), void 0));
}

exports.Base = Base;
exports.Button = Button;
exports.Checkbox = Checkbox;
exports.HTMLText = HTMLText;
exports.Header = Header;
exports.Icon = Icon;
exports.Input = Input;
exports.Label = Label;
exports.Loader = Loader;
exports.Modal = Modal;
exports.Notification = Notification;
exports.OverlineText = OverlineText;
exports.Select = Select;
exports.Stack = Stack;
exports.Text = Text;
exports.Textarea = Textarea;
exports.Toggle = Toggle;
exports.ToggleSwitch = ToggleSwitch;
//# sourceMappingURL=index.js.map
